import React, { useEffect, useState, useRef } from "react";
import MetaTags from "react-meta-tags";

const Academia = () => {

    return (<>Academia Index</>)
}

export default Academia;